import { Component, signal, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JwtService } from 'src/auth/services/jwt.service';
import { AuthClient, AvailableEdOrgDto } from 'src/shared/services/api.service';

@Component({
  selector: 'cert-ed-org-selection',
  templateUrl: './ed-org-selection.component.html',
  styles: ``,
  standalone: false,
})
export class EdOrgSelectionComponent implements OnInit {
  dataLoaded = signal(false);
  selectedEdOrgId!: number;
  edOrgOptions = signal<AvailableEdOrgDto[]>([]);
  currentEdOrgId!: number;
  currentEdOrgName!: string;

  constructor(
    private readonly activeModal: NgbActiveModal,
    private readonly authClient: AuthClient,
    private readonly jwtService: JwtService,
  ) {}

  ngOnInit() {
    this.currentEdOrgId = this.jwtService.currentEdOrgId!;
    this.currentEdOrgName = this.jwtService.currentEdOrgName!;

    this.authClient.getAvailableEdOrgs().subscribe((x) => {
      this.edOrgOptions.set(x);
      this.dataLoaded.set(true);
    });
  }

  selectEdOrg(edOrg: AvailableEdOrgDto) {
    this.selectedEdOrgId = edOrg.edOrgId;
  }

  onChange() {
    this.activeModal.close(this.selectedEdOrgId);
  }

  close() {
    this.activeModal.dismiss();
  }
}
